<app-header-buscar></app-header-buscar>
<header class="iguau-header" [class.scrolled]="isScrolled" aria-label="Cabecera principal de iGuau">
  <div class="container-fluid ig-header-inner">
    <div class="ig-brand"><app-header-logo [isScrolled]="isScrolled" [class.compact]="isScrolled"></app-header-logo></div>
    <nav class="ig-navigation" aria-label="Navegación principal"><app-header-menu [isScrolled]="isScrolled" [class.compact]="isScrolled"></app-header-menu></nav>
    <div class="ig-actions">
      <button type="button" class="ig-search" data-bs-toggle="modal" data-bs-target="#modalBusqueda" aria-label="Buscar mascotas y usuarios" title="Buscar mascotas y usuarios">
        <i class="fa-solid fa-magnifying-glass" aria-hidden="true"></i><span>Buscar mascotas, usuarios...</span>
      </button>
      <app-header-user [class.compact]="isScrolled" [misdatos]="misdatos" [busy]="busy" [isScrolled]="isScrolled"></app-header-user>
    </div>
  </div>
</header>
